import React from 'react'

import logo from '../assets/images/lg.webp';

const Header = (props) => (
    <header id="header" className="alt">
        <span className="logo"><img src={logo} alt="" width="400"/></span>
        <h1><b>Find your ideal career according to your Big 5 psychological traits</b></h1>
        <p><h2>Answer 50 questions and find your ideal career. For free!</h2></p>
    </header>
)

export default Header
